import React from "react";
import { Link } from "react-router-dom";
import { Flower2, ShieldCheck, Sun, HeartPulse, ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { Overline, SectionHeading, CTABand } from "@/components/blocks";
import { STAGES, ASSETS } from "@/data/site";

const TOPICS = [
  { icon: HeartPulse, t: "Reproductive & Hormonal Health", d: "Comprehensive care for your reproductive and hormonal wellbeing." },
  { icon: Flower2, t: "Menstrual Concerns", d: "Evaluation and management of common menstrual and cycle-related issues." },
  { icon: ShieldCheck, t: "Preventive Health", d: "Routine consultations and preventive women's healthcare." },
  { icon: Sun, t: "Menopause & Midlife", d: "Supportive guidance through perimenopause and menopause." },
];

export default function WomensHealth() {
  return (
    <div>
      <SEO title="Women's Health | Dr. Mithee's Clinic for Women, Noida" path="/womens-health" description="Reproductive and hormonal health, menstrual concerns, preventive care and menopause support at Dr. Mithee's Clinic for Women in Noida." />

      <section className="bg-gradient-to-b from-blush to-background pt-28 text-center md:pt-36">
        <div className="container-clinic pb-16">
          <Reveal><SectionHeading center overline="Women's Health" title="Whole-woman care, at every age" subtitle="Comprehensive gynaecological care — from adolescence through the reproductive years and into midlife and beyond." /></Reveal>
        </div>
      </section>

      <section className="container-clinic py-16 md:py-24">
        <div className="grid gap-6 sm:grid-cols-2">
          {TOPICS.map((c, i) => (
            <Reveal key={c.t} delay={(i % 2) * 90}>
              <div className="flex gap-5 rounded-3xl border border-soft-border bg-cream p-8">
                <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-blush text-terracotta"><c.icon className="h-5 w-5" /></span>
                <div>
                  <h3 className="font-serif text-xl text-charcoal">{c.t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-taupe">{c.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-cream py-20 md:py-28">
        <div className="container-clinic">
          <Reveal><SectionHeading center overline="A Lifelong Partnership" title="Care Through Every Stage of Womanhood" /></Reveal>
          <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {STAGES.map((s, i) => (
              <Reveal key={s.title} delay={(i % 4) * 70}>
                <div className="h-full rounded-2xl border border-soft-border bg-background p-6">
                  <span className="font-serif text-sm text-gold">0{i + 1}</span>
                  <h3 className="mt-1 font-serif text-lg text-charcoal">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-taupe">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-12 text-center">
            <Link to="/appointment" data-testid="womens-book-btn" className="inline-flex items-center gap-2 rounded-full bg-terracotta px-8 py-4 font-sans text-sm font-semibold text-cream transition-colors hover:bg-terracotta-dark">
              Book an Appointment <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
